import React from 'react';
import Grid from 'material-ui/Grid';
import { Link } from 'react-router-dom';

const footer = () => {
  function getNowYear(){
    let now = new Date();
    return now.getFullYear();
  }
  return (
    <footer className="footer">
      <div className="container footer-container">
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Link to="/privacypolicy/" className="policy-link right">PRIVACY POLICY</Link>
          <div className="copyright left">Copyright(C)1998-{getNowYear()} JLN Co.,Ltd. All rights reserved.</div>
        </Grid>
      </Grid>
      </div>
    </footer>
  )
}

export default footer;


// WEBPACK FOOTER //
// ./src/component/Footer.js